import { Component, OnInit, Input } from "@angular/core";
import { AzureSearchService } from "@rubbl-azure-search";
import { CartItem, MachineCardAddToCartComponent } from "@rubbl-cart";
import { LogService, MarketTrackingEvents, ModalService } from "@rubbl-core";
import { InventoryItem } from "@rubbl-inventory";
import { deepClone } from "fast-json-patch";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-add-to-cart-footer",
  templateUrl: "./add-to-cart-footer.component.html",
  styleUrls: ["./add-to-cart-footer.component.scss"],
})
export class AddToCartFooterComponent implements OnInit {
  @Input() machine: InventoryItem;
  @Input() cartItem: CartItem;
  @Input() machineInCart: boolean;

  constructor(
    private logService: LogService,
    private modalService: ModalService,
    private azureSearchService: AzureSearchService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {}

  addToCart() {
    // here
    this.logService.trackEvent(MarketTrackingEvents.Cart.InitialAddToCartClick, { inventoryId: this.machine.id });

    const modalRef = this.modalService.standardModal(MachineCardAddToCartComponent, true);
    modalRef.componentInstance.machine = deepClone(this.machine);
    modalRef.componentInstance.machineInCart = false;
    modalRef.result.then(
      result => {},
      () => {},
    );
  }

  editCartItem(cartItem: CartItem) {
    this.azureSearchService.getOne(cartItem.inventoryItem.id, "machines").subscribe((machine: InventoryItem) => {
      const modalRef = this.modalService.standardModal(MachineCardAddToCartComponent, true);
      modalRef.componentInstance.machine = machine;
      modalRef.componentInstance.machineInCart = true;
      modalRef.componentInstance.inCheckout = true;
      modalRef.componentInstance.cartItem = deepClone(cartItem);
      this.cartItem = null;
      modalRef.result.then(
        result => {
          this.toastrService.success(`Item updated`, null, { positionClass: "toast-top-center" });
        },
        () => {
          this.cartItem = modalRef.componentInstance.cartItem;
        },
      );
    });
  }

  buttonText(): string {
    if (this.machine.status != "Available" && this.machine.status != "Onboarding") {
      return "Not available";
    }

    if (!this.machineInCart) {
      return "Book Now";
    }

    return "Added";
  }
}
